import React from 'react';
import img_media from '../../../components/assets/Illustracion_media_superior.png';
import img_universitarios from '../../../components/assets/Illustracion_universitarios.png';
import { styled } from '@mui/material/styles';
import lem_media from '../../../components/assets/lem_media.png';
import lem_uni from '../../../components/assets/lem_uni.png';
import { useNavigate } from "react-router-dom";
import routes from '../../../routers/routes';
import { Stack, Box } from '@mui/material';

const Img = styled('img')({
  maxWidth: '100%',
  maxHeight: 140,
  objectFit: 'contain',
});

const ImgTitle = styled('img')({
  maxWidth: '100%',
  maxHeight: 140,
  objectFit: 'contain',
});

const ProgramStack = styled(Stack)({
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0px 3px 6px 0 rgb(0 0 0 / 63%)',
  // height: 200,
  padding: '16px',
  borderRadius: '16px',
  cursor: 'pointer',
  transition: 'box-shadow 500ms',
  '&:hover': {
    // boxShadow: '0px 3px 6px 0 rgb(0 0 0 / 63%), 0px 3px 0px 8px rgb(38 140 131 / 26%), 0px 3px 0px 15px #268c8336',
    boxShadow: '0px 3px 6px 0 rgb(0 0 0 / 63%), 0px 0px 0px 6px rgb(255 255 255), 0px 0px 0px 13px rgb(38 140 131)',
  },
});

const Programas = (props) => {
  let navigate = useNavigate();

  return (
    <Stack alignItems="center">
      <Stack  sx={{ maxWidth: '1200px', width: '100%', py: 5, px: '5%', boxSizing: 'border-box' }}>
        <Box sx={{ typography: 'h4', fontWeight: 'bold', color: '#3E3D3D' }}>Programas</Box>
        <Stack direction="row" justifyContent="space-around" sx={{ mt: 2}}>
          <ProgramStack onClick={() => navigate(routes.lemMS)} sx={{ width: { xs: '33%', sm: 200 }}}>
            <ImgTitle src={lem_media} alt="Líderes en Movimiento Media Superior" />
            <Img src={img_media} alt="Líderes en Movimiento Media Superior" />
          </ProgramStack>
          <ProgramStack onClick={() => navigate(routes.lemU)} sx={{ width: { xs: '33%', sm: 200 }}}>
            <ImgTitle src={lem_uni} alt="Líderes en Movimiento Universitarios" />
            <Img src={img_universitarios} alt="Líderes en Movimiento Universitarios" />
          </ProgramStack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Programas;
